module.exports = __webpack_public_path__ + "static/img/solution_mainten_bg.8e18876c.png";